import { useCallback } from "react";
import { useGetState, useSetState, LastImpulseName } from "../components/ReduxProvider";

const TEN_MINUTES = 10 * 60 * 1000;

export const useSetLastImpulse = () => {
  const setLastImpulse = useSetState("lastImpulse");
  const lastImpulse = useGetState("lastImpulse");

  return useCallback(
    (name: LastImpulseName | undefined, options?: { skipIfRecent?: boolean }) => {
      if (name === lastImpulse?.name) return;

      if (!name) {
        setLastImpulse(undefined);
        return;
      }

      const now = Date.now();
      const isRecent = lastImpulse && now - lastImpulse.timestamp < TEN_MINUTES;

      if (options?.skipIfRecent && isRecent) {
        return;
      }
      setLastImpulse({ name, timestamp: now });
    },
    [setLastImpulse, lastImpulse]
  );
};
